var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF8D3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4526 6.11507C11.6252 6.03903 11.8119 5.99984 12.0005 6C12.1891 6.00005 12.3756 6.03939 12.5481 6.11552C12.7206 6.19165 12.8753 6.3029 13.0024 6.44217C13.1295 6.58144 13.2262 6.74567 13.2863 6.92439C13.3464 7.10311 13.3686 7.29239 13.3514 7.48016L12.8105 13.4335C12.7894 13.6336 12.695 13.8189 12.5455 13.9536C12.3959 14.0882 12.2018 14.1628 12.0005 14.1628C11.7993 14.1628 11.6052 14.0882 11.4556 13.9536C11.3061 13.8189 11.2117 13.6336 11.1906 13.4335L10.6482 7.48016C10.631 7.29226 10.6533 7.10286 10.7134 6.92404C10.7736 6.74522 10.8704 6.58091 10.9977 6.44162C11.125 6.30233 11.2799 6.19111 11.4526 6.11507Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.297 16.7036C13.297 17.4196 12.7166 18 12.0006 18C11.2846 18 10.7042 17.4196 10.7042 16.7036C10.7042 15.9877 11.2846 15.4073 12.0006 15.4073C12.7166 15.4073 13.297 15.9877 13.297 16.7036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/yellowWarning.2741d0bfe02e736b6591bc47c4c4a1c3.svg";
export { ForwardRef as ReactComponent };